import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_65qc29zk: FaireBrandEntity = {
  token: "b_65qc29zk",
  type: "brand",
  name: "Simply Gum",
  avatarUrl:
    "https://cdn.faire.com/fastly/82bb2f7cf7c72e860065bc337b8b8c240a72b6729b8edade658938dbec29dba4.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/7534004cb7379653c664ad2cd93401b4c0b83ec73e6831322240b2bec3646120.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/82bb2f7cf7c72e860065bc337b8b8c240a72b6729b8edade658938dbec29dba4.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7534004cb7379653c664ad2cd93401b4c0b83ec73e6831322240b2bec3646120.jpeg",
  location: "New York, NY, USA",
  minimumOrderDollars: 75,
  rating: 4.9,
  reviewCount: 353,
  isTopShop: true,
  isInsider: true,
  description:
    "Our founder, Caron, started Simply in 2014 after she discovered that regular chewing gum was made of a synthetic plastic base. She started making batches of gum in her apartment using a tree sap (chicle) base & sold the first Simply Gum products in stores throughout NYC. As Simply continues to expand, we bring our commitment to good ingredients, delicious taste, and beautiful packaging to the development of each of our new products.\n",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:54:54.689Z",
    importedBy: "entity-db-cli",
  },
};
